import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { emptyComponent } from './empty.component';

import { TranslateModule } from '@ngx-translate/core';


@NgModule({
    declarations: [emptyComponent],
    imports: [CommonModule, TranslateModule],
    exports: [emptyComponent]
})

export class EmptyModule { }
